import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import imgBtnClassico from '../components/img1.jpg';
import imgBtnAlquimia from '../components/img6.jpg';
import imgBtnPure from '../components/img5.jpg';

const CandlesSection = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const collections = [
    {
      name: 'Colecção Pure',
      path: '/collection/pure',
      description: 'Minimalismo e sofisticação na sua forma mais pura',
      image: imgBtnPure,
      backgroundImage: imgBtnPure,
      gradient: 'from-[#FEFEFE] to-[#F5F5F5]',
      textColor: 'text-[#8B4513]',
      accentColor: 'text-[#A0522D]'
    },
    {
      name: 'Alquimia',
      path: '/collection/alquimia',
      description: 'Pó de fada em cada frasco',
      image: imgBtnAlquimia,
      backgroundImage: imgBtnAlquimia,
      gradient: 'from-[#E8D5C4] to-[#D4C5B0]',
      textColor: 'text-[#8B4513]',
      accentColor: 'text-[#A0522D]'
    },
    {
      name: 'Clássico',
      path: '/collection/classico',
      description: 'Elegância em cada vela',
      image: imgBtnClassico,
      backgroundImage:  imgBtnClassico,
      gradient: 'from-[#F5E6D3] to-[#E8D5C4]',
      textColor: 'text-[#8B4513]',
      accentColor: 'text-[#A0522D]'
    }
  ];

  return (
    <div className="min-h-screen bg-pure_fundo">
      <Header />
      
      {/* Hero Section with Background */}
      <section className="relative py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://images.pexels.com/photos/7078360/pexels-photo-7078360.jpeg"
            alt="Luxury candles background"
            className="w-full h-full object-cover opacity-30"
          />
          <div className="absolute inset-0 bg-pure_fundo"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl font-lora text-pure_titulo mb-6">
            Velas
          </h1>
          <p className="text-xl max-w-3xl mx-auto leading-relaxed font-montserrat text-pure_btn1_txt">
            Descubra as nossas coleções de velas artesanais,<br/> um pedaço de aconchego em cada fragrância 
          </p>
        </div>
      </section>

      {/* Collections Grid */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-16">
            {collections.map((collection, index) => (
              <div key={collection.name} className="group">
                <Link 
                  to={collection.path}
                  className="block relative overflow-hidden rounded-3xl shadow-2xl hover:shadow-3xl transition-all duration-500 hover:scale-105"
                >
                  {/* Collection Background Image */}
                  <div className="aspect-w-16 aspect-h-20 relative">
                    <img 
                      src={collection.backgroundImage} 
                      alt={`${collection.name} collection background`}
                      className="w-full h-96 object-cover"
                    />
                    <div className={`absolute inset-0 bg-pure_fundo opacity-70`}></div>
                    
                    {/* Overlay Content */}
                    <div className="absolute inset-0 flex flex-col justify-center items-center text-center p-8">
                      <h2 className={`text-3xl md:text-4xl font-bold text-pure_titulo mb-6`} style={{ fontFamily: 'Dream Avenue, serif' }}>
                        {collection.name}
                      </h2>
                      {/* 
                      <p className={`text-lg leading-relaxed max-w-md mb-8 font-montserrat text-pure_btn1_txt`}>
                        {collection.description}
                      </p>
                      */}
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section with Background */}
      {/*
      <section className="py-24 relative">
        <div className="absolute inset-0">
          <img 
            src="https://images.pexels.com/photos/7629856/pexels-photo-7629856.jpeg"
            alt="Candles craftsmanship"
            className="w-full h-full object-cover opacity-20"
          />
          <div className="absolute inset-0 bg-white bg-opacity-70 backdrop-blur-sm"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-lora text-pure_titulo mb-6">
              Criadas para Você
            </h2>
            <p className="text-xl max-w-3xl mx-auto leading-relaxed font-montserrat text-pure_btn1_txt">
              Cada vela é feita com ingredientes premium e atenção aos detalhes.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            // Feature 1
            <div className="text-center group">
              <div className="w-20 h-20 bg-[#8B4513] rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-[#A0522D] transition-colors duration-300">
                <svg className="w-10 h-10 text-[#f5e1ce]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-[#8B4513] mb-4" style={{ fontFamily: 'The Seasons, serif' }}>
                Queima Duradoura
              </h3>
              <p className="text-[#A0522D] leading-relaxed" style={{ fontFamily: 'The Seasons, serif' }}>
                Nossa mistura premium de cera garante uma queima limpa e uniforme que dura horas de prazer.
              </p>
            </div>

            // Feature 2
            <div className="text-center group">
              <div className="w-20 h-20 bg-[#8B4513] rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-[#A0522D] transition-colors duration-300">
                <svg className="w-10 h-10 text-[#f5e1ce]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 4V2a1 1 0 011-1h8a1 1 0 011 1v2m4 0H3a1 1 0 00-1 1v4a1 1 0 001 1h.3l2.7 8.1a1 1 0 001 .7h10a1 1 0 001-.7L20.7 10H21a1 1 0 001-1V5a1 1 0 00-1-1z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-[#8B4513] mb-4" style={{ fontFamily: 'The Seasons, serif' }}>
                Fragrâncias Requintadas
              </h3>
              <p className="text-[#A0522D] leading-relaxed" style={{ fontFamily: 'The Seasons, serif' }}>
                Aromas cuidadosamente selecionados que transformam seu espaço em um santuário de conforto e luxo.
              </p>
            </div>

            // Feature 3
            <div className="text-center group">
              <div className="w-20 h-20 bg-[#8B4513] rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-[#A0522D] transition-colors duration-300">
                <svg className="w-10 h-10 text-[#f5e1ce]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-[#8B4513] mb-4" style={{ fontFamily: 'The Seasons, serif' }}>
                Design Elegante
              </h3>
              <p className="text-[#A0522D] leading-relaxed" style={{ fontFamily: 'The Seasons, serif' }}>
                Recipientes lindos que complementam sua decoração, mesmo quando a vela não está acesa.
              </p>
            </div>
          </div>
        </div>
      </section>
      */}

      <Footer />
    </div>
  );
};

export default CandlesSection;